import {DATASET_MIXPANEL} from '../../constants';
import {BaseClient} from '../utils/base-client';
import {getEventParam, processProperties} from './utils';

class EventPropertiesClient extends BaseClient {
  buildEndpoint() {
    return `api/2.0/events/properties/toptypes/`;
  }

  buildQueryParams(options = {}) {
    const {projectId, eventName, datasetId, dataGroupId, includeCustom, includeDimensionProperties, workspaceId} = {
      eventName: null,
      datasetId: DATASET_MIXPANEL,
      dataGroupId: null,
      includeCustom: false,
      ...options,
    };
    /* eslint-disable camelcase */
    return {
      project_id: projectId,
      limit: 1500,
      ...getEventParam(eventName),
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(includeCustom ? {include_custom: includeCustom} : {}),
      ...(includeDimensionProperties ? {include_dimension_props: includeDimensionProperties} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
    };
    /* eslint-enable camelcase */
  }

  processResponse(response) {
    return processProperties(response);
  }
}

export default new EventPropertiesClient();
